import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import { login as loginUser } from '../../apis/auth';
import { setSession } from '../../store/reducers/authReducer';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useExceptionHandler } from '../../hooks/useExceptionHandler';
import { useShowNotification } from '../../hooks/useShowNotification';
import { FormErrors } from '../../components/common/form/FormErrors';

export const LoginPage = () => {
    useDocumentTitle('Login');

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { handleException } = useExceptionHandler();
    const showNotification = useShowNotification('Login', 'sign-in');

    const {
        register,
        formState: { errors },
        handleSubmit
    } = useForm();

    const onSubmit = async ({ email, password }) => {
        try {
            if (isLoading === 'loading') return;

            setIsLoading(true);
            const response = await loginUser(email, password);
            setIsLoading(false);

            if (response.success) {
                showNotification(response.message, 'success');
                dispatch(setSession(response));
                navigate('/');
                return;
            }

            if (response.exception) {
                handleException(response.exception);
                return;
            }

            showNotification(response.message, 'warning');
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            showNotification('Oops something went wrong.', 'danger');
        }
    };

    const emailValidations = {
        required: 'Email is required.',
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Invalid email address.'
        }
    };

    const passwordValidations = {
        required: 'Password is required.',
        minLength: {
            value: 6,
            message: 'Password must be at least 6 characters long.'
        }
    };

    return (
        <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
            <h1 className="h3 fw-normal text-dark my-3">Login</h1>
            <FormErrors errors={errors} />
            <div className="form-floating">
                <input
                    {...register('email', emailValidations)}
                    type="email"
                    className="form-control"
                    id="emailInput"
                    placeholder="name@example.com"
                />
                <label htmlFor="emailInput">Email address</label>
            </div>
            <div className="form-floating">
                <input
                    {...register('password', passwordValidations)}
                    type="password"
                    className="form-control"
                    id="passwordInput"
                    placeholder="Password"
                />
                <label htmlFor="passwordInput">Password</label>
            </div>
            <button className="w-100 btn btn-lg btn-primary my-3" type="submit">
                Continue
            </button>
            <p className="mt-3 mb-0">Don&apos;t have an account?</p>
            <Link to="/register" className="link-primary text-decoration-none mb-3">
                Register
            </Link>
        </form>
    );
};
